import type { AbilityKey } from './abilityDefinitions'

// OR-fallback keeps existing admins/owners unaffected during the BE rollout of
// user_role_wg:write (GM-2329). Can simplify to just viewWorkplaceGiving once
// that grant has shipped to all environments.
export const canViewWGSection = (userCan: (ability: AbilityKey) => boolean): boolean =>
  userCan('manageOwners') || userCan('manageAdmins') || userCan('viewWorkplaceGiving')
